/* eslint-disable no-alert */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BuyCredits from '../../assets/credits/credits.png';
import { useBuyCredits, useGetCreditsByUserId } from '../../services';
import Counter from '../counter/counter';
import styles from './buyCredits.module.scss';

const BuyCreditComponent = ({ halfCr, fullCr }) => {
  const [isHalfDaySelected, setCredit] = useState(true);
  const buy = useBuyCredits();
  const [count, setCount] = useState(1);

  const incNum = () => {
    if (count === 10) {
      return;
    }
    if (count < 5) {
      setCount((n) => n + 1);
      return;
    }

    setCount((n) => (n === 1 ? n + 4 : n + 5));
  };

  const decNum = () => {
    if (count === 1) {
      return;
    }
    if (count <= 5) {
      setCount((n) => n - 1);
      return;
    }
    setCount((n) => (n === 5 ? n - 4 : n - 5));
  };

  let subTotal;
  let halfDayCredits = 0;
  let fullDayCredits = 0;


  switch (count) {
    case 1:
      subTotal = isHalfDaySelected ? count * 125.0 : count * 200.0;
      if (subTotal === 125) {
        halfDayCredits = count;
      } else if (subTotal === 200) {
        fullDayCredits = count;
      }
      break;
    case 2:
      subTotal = isHalfDaySelected ? count * 125.0 : count * 200.0;
      if (subTotal === 250) {
        halfDayCredits = count;
      } else if (subTotal === 400) {
        fullDayCredits = count;
      }
      break;
    case 3:
      subTotal = isHalfDaySelected ? count * 125.0 : count * 200.0;
      if (subTotal === 375) {
        halfDayCredits = count;
      } else if (subTotal === 600) {
        fullDayCredits = count;
      }
      break;
    case 4:
      subTotal = isHalfDaySelected ? count * 125.0 : count * 200.0;
      if (subTotal === 500) {
        halfDayCredits = count;
      } else if (subTotal === 800) {
        fullDayCredits = count;
      }
      break;
    case 5:
      subTotal = isHalfDaySelected ? count * 115.0 : count * 185.0;
      if (subTotal === 575) {
        halfDayCredits = count;
      } else if (subTotal === 925) {
        fullDayCredits = count;
      }
      break;
    case 10:
      subTotal = isHalfDaySelected ? count * 106.0 : count * 170.0;
      if (subTotal === 1060) {
        halfDayCredits = count;
      } else if (subTotal === 1700) {
        fullDayCredits = count;
      }
      break;
    default:
      break;
  }

  const onBuy = () => {
    buy.mutate({
      amount: subTotal.toString(),
      credit_type: isHalfDaySelected ? 'HALF' : 'FULL',
      credit: isHalfDaySelected ? halfDayCredits : fullDayCredits,
    });
  };

  useGetCreditsByUserId();

  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <div style={{ backgroundColor: '#D1BEDF' }} className="container">
          <div style={{ backgroundColor: 'white' }} className="row">
            <div className="col-5">
              <img className="pt-3 pb-3 float-right" src={BuyCredits} alt="complete-icon" />
            </div>
            <div className="col-6">
              <h3 className="pt-5">
                <strong className="text-center">Buy Credits</strong>
              </h3>
            </div>
          </div>

          <div className="row">
            <input
              type="button"
              value="Half Day"
              className={`col text-center p-3 ${styles.credit1} ${
                !isHalfDaySelected ? styles.active : ''
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setCredit(true);
              }}
            />

            <input
              type="button"
              value="Full Day"
              className={`col text-center p-3 ${styles.credit1} ${
                isHalfDaySelected ? styles.active : ''
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setCredit(false);
              }}
            />
          </div>

          <div className="border-bottom border-secondary p-2" />
          <div className="row">
            <h5 className="col text-center pt-1">
              {isHalfDaySelected
                ? `Remaining Half Day Credits : ${halfCr}`
                : `Remaining Full Day Credits : ${fullCr}`}
            </h5>
          </div>
          <div className="border-top border-secondary pb-1" />

          <table className={`table table-sm ${styles['table-bg']}`}>
            <thead>
              <tr>
                <th scope="col">Count</th>
                <th scope="col">Cost/Credit</th>
                <th scope="col">Discount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1</th>
                <td>{isHalfDaySelected ? '$125.00' : '$200.00'}</td>
                <td>0%</td>
              </tr>
              <tr>
                <th scope="row">2</th>
                <td>{isHalfDaySelected ? '$250.00' : '$400.00'}</td>
                <td>0%</td>
              </tr>
              <tr>
                <th scope="row">3</th>
                <td>{isHalfDaySelected ? '$375.00' : '$600.00'}</td>
                <td>0%</td>
              </tr>
              <tr>
                <th scope="row">4</th>
                <td>{isHalfDaySelected ? '$500.00' : '$800.00'}</td>
                <td>0%</td>
              </tr>
              <tr>
                <th scope="row">5</th>
                {/* <td>{isHalfDaySelected ? '$115.00' : '$185.00'}</td> */}
                <td>{isHalfDaySelected ? '$575.00' : '$925.00'}</td>
                <td>7.5%</td>
              </tr>
              <tr>
                <th scope="row">10</th>
                {/* <td>{isHalfDaySelected ? '$106.00' : '$170.00'}</td> */}
                <td>{isHalfDaySelected ? '$1060.00' : '$1700.00'}</td>
                <td>15%</td>
              </tr>
            </tbody>
          </table>
          <div className="text-center pl-4">
            <Counter num={count} decNum={decNum} incNum={incNum} />
          </div>
          <h4 className="text-center">
            <strong className="pl-4">Subtotal = ${subTotal}</strong>
          </h4>
          <div className="col btn-lg btn-block">
            <button
              type="button"
              className={`btn btn-secondary w-100 ${styles['credit-btn']}`}
              onClick={onBuy}>
              {isHalfDaySelected ? 'Buy Half-Day Credit' : 'Buy Full-Day Credit'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

BuyCreditComponent.propTypes = {
  halfCr: PropTypes.string,
  fullCr: PropTypes.string,
};
BuyCreditComponent.defaultProps = {
  halfCr: '',
  fullCr: '',
};
export default BuyCreditComponent;
